import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

export default function BackButton({ fallback = "/" }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={handleBack}
      sx={{
        mb: 2.5,
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 2,
        color: "#CC5500",
        border: "1px solid rgba(204,85,0,0.35)",
        backgroundColor: "rgba(204,85,0,0.05)",
        "&:hover": {
          backgroundColor: "rgba(204,85,0,0.12)",
          borderColor: "#CC5500",
        },
      }}
    >
      Back
    </Button>
  );
}